module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isTowerSupplierCo() || _vm.canAccess('project|maintenance|management|admin')) ? _c('div', [_c('el-row', {
    staticStyle: {
      "padding-top": "1.24em"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('h3', [_c('i', {
    staticClass: "fa fa-sitemap"
  }), _vm._v(" Site Structure")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [((_vm.isTowerSupplierCo() || _vm.isManager('project|maintenance')) && (_vm.rowData.status !== 'Active' || _vm.structures.length === 0)) ? _c('structure-action', {
    attrs: {
      "heading": 'Add Structure: ' + _vm.rowData.siteName,
      "site-id": _vm.rowData.id,
      "read-only": _vm.readOnly
    },
    on: {
      "update": _vm.updated
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('div', [_c('center', [_c('span', {
    staticClass: "fa fa-spinner fa-spin"
  })])], 1) : _c('div', [(_vm.structures.length >= 1) ? _c('div', [(_vm.structures.length == 1) ? _c('div', [_c('struct-details', {
    attrs: {
      "row-data": _vm.structures[0],
      "index": 0,
      "site-id": _vm.rowData.id,
      "read-only": _vm.readOnly
    },
    on: {
      "update": _vm.updated,
      "delete": _vm.onDelete
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.structures.length > 1) ? _c('div', [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.structures), function(s, i) {
    return _c('el-collapse-item', {
      key: s.id,
      attrs: {
        "title": s.name
      }
    }, [_c('struct-details', {
      attrs: {
        "row-data": s,
        "site-id": _vm.rowData.id,
        "index": i,
        "read-only": _vm.readOnly
      },
      on: {
        "update": _vm.updated,
        "delete": _vm.onDelete
      }
    })], 1)
  }), 1)], 1) : _vm._e()]) : _c('div', [_c('center', [_c('i', [_vm._v("No structure information found")])]), _vm._v(" "), _c('br')], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a41c666e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/projects/SiteStruct.vue
// module id = 1607
// module chunks = 0